import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessNoteEntity } from './process-note.entity';

@Entity('_note')
export class NoteEntity extends BaseEntity {
	@Column('text', { name: '_note', nullable: true })
	public note!: string | null;

	@Column('varchar', { name: '_type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('int', { name: '_userID', nullable: true, unsigned: true })
	public userId!: number | null;

	@Column('datetime', {
		name: '_lastUpdated',
		nullable: true,
		default: () => 'CURRENT_TIMESTAMP',
	})
	public lastUpdated!: Date | null;

	@OneToMany(() => ProcessNoteEntity, (processNote) => processNote.fkNote, {})
	public processNotes!: Array<ProcessNoteEntity>;
}
